export default "__VITE_ASSET__DGqQ5A6x__"